export default from './EditableTagGroup';



// WEBPACK FOOTER //
// ./src/elements/editable-tag-group/index.jsx